import { SettleTotal } from './total'

export function Unsettle() {

    return (
        <SettleTotal />
    )
}
